import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SalesReturnListRes;
export const SalesReturnListTodo = createAsyncThunk('SalesReturnList', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sales_return_list',
            data: {
                "fin_year": data?.fin_year,
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "pageing":data?.pageSize,
                "ilimit": data?.pageLimit,
                "vfrom_date": data?.fromDate,
                "vto_date":data?.toDate,
                "month":data?.month,
                "vcrn_code": ""
                
            },
            headers: { "Content-Type": "application/json" },

        })
        return SalesReturnListRes = res.data

    } catch (error) {
        return SalesReturnListRes = error.response.data
    }
});

const SalesReturnListSlice = createSlice({
    name: 'SalesReturnList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SalesReturnListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(SalesReturnListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SalesReturnListSlice.reducer; 